import { withStyles } from '@material-ui/core/styles';
import MuiTab from '@material-ui/core/Tab';
var Tab = withStyles(function (theme) { return ({
    root: {
        backgroundColor: theme.palette.grey[50],
        borderTopLeftRadius: theme.spacing(1),
        borderTopRightRadius: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: 18,
        textTransform: 'none',
        border: "0.5px solid #FDFDFD"
    },
    selected: {
        color: '#000',
        zIndex: 10,
        boxShadow: '0px 30px 40px rgba(0, 0, 0, 0.2)',
        backgroundColor: theme.palette.common.white,
        borderBottomColor: theme.palette.common.white
    },
    disabled: {
        color: theme.palette.grey[300]
    },
    indicator: {
        borderColor: theme.palette.text.secondary
    },
    textColorInherit: {
        opacity: 1,
        '&.Mui-disabled': {
            opacity: 1
        }
    }
}); })(MuiTab);
export default Tab;
//# sourceMappingURL=Tab.js.map